import { CamelCaseKeys, Form, FormSubmission, FormsKeys } from '@uplift/types';
import { restClient } from '../client';
import { MedicalDocumentRecord } from './medicalDocument';


export enum PatientDocumentType {
  static = 'static',
  form = 'form',
  medicalRecord = 'medical_record',
}


export enum PatientStaticDocumentKey {
  financialResponsibility = 'financial_responsibility',
  privacyPolicy = 'privacy_policy',
  consentToTreat = 'consent_to_treat',
}


export type PatientStaticDocument = CamelCaseKeys<{
  type: PatientDocumentType.static;
  patient_id: string;
  document_key: PatientStaticDocumentKey;
  uploaded_at: string;
  uploaded_by: string;
}>;


export type PatientFormDocument = CamelCaseKeys<{
  type: PatientDocumentType.form;
  patient_id: string;
  document_key: FormsKeys;
  uploaded_at: string;
  uploaded_by: string;
  form: Form;
  submission: FormSubmission;
}>;

export type PatientUploadedMedicalDocument = CamelCaseKeys<MedicalDocumentRecord>;


export type PatientDocument =
  | PatientStaticDocument
  | PatientFormDocument
  | PatientUploadedMedicalDocument;


export const getPatientDocuments = async (patientId: string, documentTypes?: PatientDocumentType[]) =>
  await restClient.request<{ data: { documents: PatientDocument[]; all_documents_count: number } }>(`/api/v1/patient/${patientId}/documents`, {
    method: 'POST',
    data: {
      document_types: documentTypes,
    }
  });
